module.exports = __webpack_public_path__ + "img/document.637e2763.png";